import Service from './abstract';
import _ from 'lodash';
const withPersonSmall = 'person,person.attributes,person.attributes.attribute';
const withPersonDocuments = 'person.documents,person.documents.type';
const withRequestFile = 'originationRequestsFiles,originationRequestsFiles.file';

const defaultOptions = {
    with: `${withPersonSmall},${withPersonDocuments},${withRequestFile}`,
};

const defaultFiles = {
    with: `${withRequestFile}`,
};

class Signs extends Service {
    constructor () {
        super('signs/');
        // super('');
    }

    getRequests (data = {}) {
        return this.get({
            url: `${this.basePath}/signs/origination/requests`,
            qs: _.defaultsDeep({}, data, defaultOptions),
        }).then(requests => {
            return this.normalizeAll(requests);
        });
    }

    getById (id) {
        return this.get({
            // TODO fix base url. When cross domain resolve for PUT method
            url: `${this.basePath}/signs/origination/requests/${id}`,
            qs: defaultOptions,
        });
    }

    createUser (data = {}) {
        return this.post({
            url: `${this.basePath}/signs/origination/requests`,
            data
        });
    }

    upDateUser (data, id) {
        return this.put({
            url: `${this.basePath}/signs/origination/requests/${id}`,
            data
        }).then(requests => {
            return requests;
        });
    }

    downloadFile (idRequest, idFile) {
        return this.get({
            url: `${this.basePath}/signs/origination/requestsFiles/${idRequest}/files/${idFile}/download`
        });
    }

    upDateFiles (data, id) {
        return this.put({
            url: `${this.basePath}/signs/origination/requests/${id}`,
            json: false,
            data
        }).then(requests => {
            return requests;
        });
    }

    removeFile (id) {
        return this.delete({
            url: `${this.basePath}/signs/origination/requests/${id}`,
        });
    }

    filesList (id) {
        return this.get({
            url: `${this.basePath}/signs/origination/requests/${id}`,
            qs: defaultFiles
        });
    }

    uploadFile (data, id) {
        return this.post({
            url: `${this.basePath}/suppliers/${id}/files`,
            json: false,
            data
        });
    }

    anular (id) {
        return this.put({
            url: `${this.basePath}/signs/origination/requests/${id}/cancel`
        });
    }

    normalize (request) {
        if (_.isNil(request)) {
            return request;
        }

        if (request.insurance_plan?.insurance?.product) {
            // Prepare product attributes
            if (request.insurance_plan.insurance.product.attributes) {
                request.insuranceAttributes = _.keyBy(request.insurance_plan.insurance.product.attributes, 'description');
            }
        }

        return request;
    }
}

export default new Signs();
